import { SerializedStyles, css } from '@emotion/react';
import * as React from 'react';

import { Colors, colors } from '~src/theme/colors';
import { fontStyles } from '~src/theme/fontStyles';
import { Spacing } from '~src/theme/spacing';

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
  color?: keyof Colors;
  padding?: keyof Spacing;
  textAlign?: React.CSSProperties['textAlign'];
  display?: React.CSSProperties['display'];
  paddingBottom?: keyof Spacing;
  paddingTop?: keyof Spacing;
  paddingLeft?: keyof Spacing;
  role?: string;
  textStyle?: SerializedStyles;
  ariaLabel?: string;
}

export const Text: React.FunctionComponent<Props> = ({
  color,
  padding,
  textAlign,
  display,
  paddingBottom,
  paddingTop,
  paddingLeft,
  role,
  textStyle,
  ...props
}) => (
  <span
    css={css({
      display: display ? display : 'inline-block',
      color: color ? color : colors.black,
      ...(paddingBottom && { paddingBottom: paddingBottom }),
      ...(paddingTop && { paddingTop: paddingTop }),
      ...(paddingLeft && { paddingLeft: paddingLeft }),
      ...(padding && { padding: padding }),
      ...(textAlign && { textAlign }),
      ...defaultTextStyle,
      ...textStyle,
    })}
    role={role}
    {...props}
  >
    {props.children}
  </span>
);

export const defaultTextStyle = css({
  fontFamily: '"Inter var", "Inter"',
  fontStyle: 'normal',
  ...fontStyles.px12_16,
  fontVariationSettings: "'wght' 400",
  textTransform: 'none',
  letterSpacing: 0.1,
});

export const getCompleteTextStyle = (customTextStyle: SerializedStyles) => {
  return { ...defaultTextStyle, ...customTextStyle };
};

Text.displayName = 'Text';
